import {combineReducers} from 'redux';
import {
    isLogin, isLoadedLogin, isShowTwoFactor, verifyEmail,
} from './login';
import {
    clientId, vuzId, apiDomainAuth, apiDomainVikon, apiDomainFilemanager, vuzName,
} from './config';
import {
    profileBasic,
    loadingProfileBasic,
    loadedProfileBasic,
    mailingRegion,
    mailingTownType,
} from './profileBasic';
import {
    schemeIdentityDocument,
    identityDocument,
    loadingIdentityDocument,
    loadedIdentityDocument,
} from './identityDocument';
import {
    typesEducationDocuments,
    schemesEducationDocuments,
    educationDocuments,
    loadingEducationDocuments,
    loadedEducationDocuments,
} from './education';
import {
    typesEgeResults,
    schemesEgeResults,
    egeResults,
    loadingEgeResults,
    loadedEgeResults,
} from './egeResults';
import {
    typesEgeDocuments,
    schemesEgeDocuments,
    egeDocuments,
    loadingEgeDocuments,
    loadedEgeDocuments,
} from './egeDocuments';
import {
    typesAchievements,
    schemesAchievements,
    achievements,
    loadingAchievements,
    loadedAchievements,
} from './achievements';
import {
    typesPrivileges,
    schemesPrivileges,
    privileges,
    loadingPrivileges,
    loadedPrivileges,
} from './privileges';
import {
    typesOtherDocuments,
    schemesOtherDocuments,
    otherDocuments,
    loadingOtherDocuments,
    loadedOtherDocuments,
} from './otherDocuments';
import {
    zajavls,
    loadingZajavls,
    loadedZajavls,
    contestDialogOpenZajavls,
    contestEditFormZajavls,
    zajavlEditUuidZajavls,
    sprCompetitionsZajavls,
    sprAllowedForAdmissionCompGroupsNames,
    allowedOnlineZajavls,
    requirementsDocuments,
    templatesDocuments,
    zajavlsConsentOrRefusalPageLoaded,
    commentsZajavls,
    historyZajavl,
    loadingHistoryZajavl,
} from './zajavls';
import {
    settingsPageLoaded,
    twoFactorLogin,
} from './settings';
import {loadingApplication, notificationsApplication, wrongPage} from './application';
import {files} from './files';
import {digitalProfileSettings, digitalProfileCabinetLoaded} from './digitalProfileCabinet';
import {
    exams, examEditStatus, examEdit, applicantExams, examDeleteStatus, examDelete,
} from './exams';
import {captchaKey, captchaImg} from './captcha';
import {isLoadedRatingApplicants, ratingApplicantsLinks} from './ratingApplicants';

const allReducers = combineReducers({
    isLogin,
    isLoadedLogin,
    isShowTwoFactor,
    verifyEmail,

    clientId,
    vuzId,
    apiDomainAuth,
    apiDomainVikon,
    apiDomainFilemanager,
    vuzName,

    profileBasic,
    loadingProfileBasic,
    loadedProfileBasic,
    mailingRegion,
    mailingTownType,

    schemeIdentityDocument,
    identityDocument,
    loadingIdentityDocument,
    loadedIdentityDocument,

    typesEducationDocuments,
    schemesEducationDocuments,
    educationDocuments,
    loadingEducationDocuments,
    loadedEducationDocuments,

    typesEgeResults,
    schemesEgeResults,
    egeResults,
    loadingEgeResults,
    loadedEgeResults,

    typesEgeDocuments,
    schemesEgeDocuments,
    egeDocuments,
    loadingEgeDocuments,
    loadedEgeDocuments,

    typesAchievements,
    schemesAchievements,
    achievements,
    loadingAchievements,
    loadedAchievements,

    typesPrivileges,
    schemesPrivileges,
    privileges,
    loadingPrivileges,
    loadedPrivileges,

    typesOtherDocuments,
    schemesOtherDocuments,
    otherDocuments,
    loadingOtherDocuments,
    loadedOtherDocuments,

    zajavls,
    loadingZajavls,
    loadedZajavls,
    contestDialogOpenZajavls,
    contestEditFormZajavls,
    zajavlEditUuidZajavls,
    sprCompetitionsZajavls,
    sprAllowedForAdmissionCompGroupsNames,
    allowedOnlineZajavls,
    requirementsDocuments,
    templatesDocuments,
    commentsZajavls,
    historyZajavl,
    loadingHistoryZajavl,

    zajavlsConsentOrRefusalPageLoaded,
    settingsPageLoaded,
    twoFactorLogin,

    loadingApplication,
    notificationsApplication,
    wrongPage,

    files,

    digitalProfileSettings,
    digitalProfileCabinetLoaded,

    exams,
    examEditStatus,
    examEdit,
    applicantExams,
    examDeleteStatus,
    examDelete,

    captchaKey,
    captchaImg,

    isLoadedRatingApplicants,
    ratingApplicantsLinks,
});

export default allReducers;
